var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("div", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("operation.franchisee_detail"))),
      ]),
      _c(
        "el-descriptions",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "detail-content",
          attrs: { column: 1, border: "" },
        },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.franchisee_no") } },
            [_vm._v(_vm._s(_vm.detail.franchisee_no || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.franchisee_name") } },
            [_vm._v(_vm._s(_vm.detail.franchisee_name || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.region") } },
            [_vm._v(_vm._s(_vm.detail.country_code || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.currency") } },
            [_vm._v(_vm._s(_vm.detail.currency || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.contact_name") } },
            [_vm._v(_vm._s(_vm.detail.contact_name || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.contact_phone") } },
            [_vm._v(_vm._s(_vm.detail.contact_phone || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.contact_email") } },
            [_vm._v(_vm._s(_vm.detail.contact_email || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.remark") } },
            [_vm._v(_vm._s(_vm.detail.remark || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.description") } },
            [_vm._v(_vm._s(_vm.detail.description || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("operation.create_time") } },
            [_vm._v(_vm._s(_vm.detail.create_time || "-"))]
          ),
          _c(
            "el-descriptions-item",
            { attrs: { label: _vm.$t("merchantAccount.update_time") } },
            [_vm._v(_vm._s(_vm.detail.update_time || "-"))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "page-footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }